module.exports = __webpack_public_path__ + "img/payment-logos.50cd2dd0.png";